import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectMembersPage } from '@/features/access/project-members/project-members-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Membres du projet : rejoints depuis la vue d'ensemble du projet (le projet est dans l'URL). */
export const Route = createFileRoute('/$tenant/projects/$projectId/members/')({
  component: ProjectMembersRoute,
});

function ProjectMembersRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="overview"
      crumbs={[{ label: t('access.projectMembers.title') }]}
    >
      <ProjectMembersPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
